function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
import React from "react";
import { useUIDSeed } from "react-uid";
import { Body, CallToAction, Heading, Subheading } from "../../atoms";
import { ArrowRight } from "../../icons";
import { Section } from "../../molecules";
export var EventPageIntro = function(param) {
    var label = param.label, pretitle = param.pretitle, title = param.title, introtitle = param.introtitle, content = param.content, callToActions = param.callToActions, className = param.className, enableLines = param.enableLines;
    var seed = useUIDSeed();
    return /*#__PURE__*/ React.createElement(Section, {
        container: true,
        lines: enableLines ? "dark" : false,
        className: className
    }, /*#__PURE__*/ React.createElement("div", null, !!label && /*#__PURE__*/ React.createElement(Subheading, {
        className: "mb-5"
    }, label), !!pretitle && /*#__PURE__*/ React.createElement(Heading, {
        variant: "h1",
        className: "text-brand-primary-base"
    }, pretitle), /*#__PURE__*/ React.createElement(Heading, {
        variant: "h1"
    }, title)), !!(introtitle || content || (callToActions === null || callToActions === void 0 ? void 0 : callToActions.length)) && /*#__PURE__*/ React.createElement("div", {
        className: "grid items-center gap-6 grid-flow-row auto-rows-auto grid-cols-1 mt-7 md:mt-9 md:ml-[33%]"
    }, !!introtitle && /*#__PURE__*/ React.createElement(Subheading, {
        className: "text-brand-primary-base"
    }, introtitle), !!content && /*#__PURE__*/ React.createElement(Body, null, content), !!(callToActions === null || callToActions === void 0 ? void 0 : callToActions.length) && /*#__PURE__*/ React.createElement("div", {
        className: "flex items-center flex-wrap -m-4"
    }, callToActions.map(function(action) {
        return /*#__PURE__*/ React.createElement(CallToAction, _extends({
            key: seed(action)
        }, action, {
            style: "link",
            className: "m-4",
            icon: /*#__PURE__*/ React.createElement(ArrowRight, null)
        }));
    }))));
};

//# sourceMappingURL=EventPageIntro.js.map